module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-lg-6"
  }, [_c('h5', [_vm._v(_vm._s(_vm.graphTitle))]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "col col-lg-5"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('graph.time_period_filter_label')))]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('graph.time_period')) + " :")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "custom-select",
    attrs: {
      "required": "",
      "options": _vm.periodOptions
    },
    on: {
      "change": function($event) {
        return _vm.$emit('filter-graph', {
          period: _vm.sPeriod,
          ibans: _vm.sIbans,
          contacts: _vm.sContacts,
          docTypes: _vm.sDocTypes
        })
      }
    },
    model: {
      value: (_vm.sPeriod),
      callback: function($$v) {
        _vm.sPeriod = $$v
      },
      expression: "sPeriod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (!_vm.filterDocuments) ? _c('b-form-group', {
    attrs: {
      "label": _vm.$i18n.t('filter.fltr_cntct')
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.contactOptions
    },
    model: {
      value: (_vm.sContacts),
      callback: function($$v) {
        _vm.sContacts = $$v
      },
      expression: "sContacts"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (false) ? _c('b-button', {
    on: {
      "click": function($event) {
        return _vm.$emit('filter-graph', {
          period: _vm.sPeriod,
          ibans: _vm.sIbans,
          contacts: _vm.sContacts,
          docTypes: _vm.sDocTypes
        })
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('filter.appl_fltr')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d6a4f1c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6a4f1c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/statistics/components/GraphPanel.vue
// module id = 2511
// module chunks = 2